import { BrowserRouter as Router } from 'react-router-dom'
import { Suspense } from 'react'
import { HelmetProvider } from 'react-helmet-async'
import { QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider } from './contexts/AuthContext'
import { CurrencyProvider } from './contexts/CurrencyContext'
import { ThemeProvider } from './contexts/ThemeContext'
import ErrorBoundary from './components/layout/ErrorBoundary'
import { AppRoutes } from './appRoutes'
import { createAppQueryClient } from './queryClient'
import { ReauthPrompt } from './components/auth/ReauthPrompt'

const PageLoader = () => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      fontSize: '1.2rem',
      color: '#666',
    }}
  >
    Loading...
  </div>
)

const queryClient = createAppQueryClient()

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <Router>
            <HelmetProvider>
              <AuthProvider>
                <CurrencyProvider>
                  <Suspense fallback={<PageLoader />}>
                    <AppRoutes />
                  </Suspense>
                  {/* "Confirm it's you" for billing/team/integration changes (utils/reauth.ts). */}
                  <ReauthPrompt />
                </CurrencyProvider>
              </AuthProvider>
            </HelmetProvider>
          </Router>
        </QueryClientProvider>
      </ThemeProvider>
    </ErrorBoundary>
  )
}

export default App
